import { memo } from "react";
import { literals } from "@/constants/literals";
import useReceptionDataStore from "@/store/useReceptionData.store";
import ExpandableOrderHeader from "../../components/explandable-order-header/ExpandableOrderHeader";

export interface ReceptionOrderHeaderProps {
  newOrderText?: boolean;
  inResumePage?: boolean;
}

const ReceptionOrderHeader = ({
  newOrderText,
  inResumePage,
}: ReceptionOrderHeaderProps) => {
  const { receptionData, receptionGroupData } = useReceptionDataStore();

  const basicInformation: [
    { label: string; value: string },
    { label: string; value: string },
  ] = [
    {
      label: literals.step,
      value:
        receptionData.step === literals.inNoServ
          ? literals.receptionEnter
          : literals.receptionExit,
    },
    {
      label: literals.customerOrderNoServ,
      value: receptionData.customerOrderNoserv,
    },
  ];

  const expandedDetails = () => {
    if (newOrderText) return;
    if (receptionData.step === literals.inNoServ) {
      return [
        {
          label: literals.orderIn,
          value: receptionData.orderIn,
        },
        {
          label: literals.serialIn,
          value: receptionData.serialIn,
        },
        {
          label: literals.client,
          value: receptionData.customer,
        },
        {
          label: literals.ownPackaging,
          value: receptionData.ownPackaging ? literals.yes : literals.no,
        },
        {
          label: literals.correctPackaging,
          value: receptionData.correctPackaging ? literals.yes : literals.no,
        },
        {
          label: literals.damagedPackaging,
          value: receptionData.damagedPackaging ? literals.yes : literals.no,
        },
      ];
    }
    return [
      {
        label: literals.orderIn,
        value: receptionData.orderIn,
      },
      {
        label: literals.serialIn,
        value: receptionData.serialIn,
      },
      {
        label: literals.workOrderHeader,
        value: receptionData.orderNumber,
      },
      {
        label: literals.client,
        value: receptionData.customer,
      },
      {
        label: literals.ownPackaging,
        value: receptionData.ownPackaging ? literals.yes : literals.no,
      },
      {
        label: literals.correctPackaging,
        value: receptionData.correctPackaging ? literals.yes : literals.no,
      },
      {
        label: literals.damagedPackaging,
        value: receptionData.damagedPackaging ? literals.yes : literals.no,
      },
      {
        label: literals.packageReference,
        value: receptionData.packagingReference,
      },
    ];
  };

  return (
    <ExpandableOrderHeader
      stand="reception"
      newOrderText={newOrderText}
      inReceptionResumePage={inResumePage}
      basicInformation={basicInformation}
      expandedInformation={expandedDetails()}
      thereAreMoreGroups={receptionGroupData.length > 0}
    />
  );
};
export default memo(ReceptionOrderHeader);
